export const ONEWAY = 'one_way';
export const ROUNDTRIP = 'round_trip';
export const MULTICITY = 'multi_city';
